import React from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './TopProperties.css';
import { useLanguageContext } from '@/hooks/context-hooks';
import topPropertiesBg from '@/assets/images/property_search_bg.png';
import { TOP_PROPERTIES, PROPERTY_CATEGORY_ID } from '@/_constant';

const TopProperties = () => {
  const navigate = useNavigate();
  const { language } = useLanguageContext();

  const properties = [
    { id: 1, title: 'Apartments', count: '2000+', image: '/home-banner/top-properties/Apartment.png' },
    { id: 2, title: 'Villas & Row houses', count: '2000+', image: '/home-banner/top-properties/Villa.png' },
    { id: 3, title: 'Plots/ land', count: '2000+', image: '/home-banner/top-properties/Plot.png' },
    { id: 4, title: 'Commercial properties', count: '2000+', image: '/home-banner/top-properties/commercial.png' },
    { id: 5, title: 'Service Apartments', count: '2000+', image: '/home-banner/top-properties/service_apartment.png' },
    { id: 6, title: 'Hospitality', count: '2000+', image: '/home-banner/top-properties/hospitality.png' },
    { id: 7, title: 'Farm house land', count: '2000+', image: '/home-banner/top-properties/Farmhouseland.png' },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '40px',
        }
      }
    ]
  };

  return (
    <div className="container py-3">
      <div className="top-properties-wrapper position-relative p-4 rounded-4 shadow-sm overflow-hidden" style={{
        backgroundImage: `url(${topPropertiesBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}>
        {/* Decorative Background Elements (optional based on screenshot) */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="fw-bold mb-0 text-warning text-uppercase" style={{ letterSpacing: '1px' }}>
            Our Top Properties
          </h4>

        </div>

        <Slider {...settings} className="top-properties-slider">
          {properties.map((item) => (
            <div key={item.id} className="px-2">
              <div
                className="card border-0 rounded-4 overflow-hidden h-100 bg-white d-flex flex-column"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(TOP_PROPERTIES, {
                  state: JSON.stringify({
                    category: 'property_sale_contract',
                    categoryId: PROPERTY_CATEGORY_ID
                  })
                })}
              >
                <div className="position-relative">
                  <img src={item.image} alt={item.title} className="w-100" style={{ height: '140px', objectFit: 'cover' }} />
                  <div className="position-absolute bottom-0 w-100 text-center text-white py-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', fontSize: '0.85rem' }}>
                    {item.count} available
                  </div>
                </div>
                <div className="card-body text-center d-flex align-items-center justify-content-center px-2 py-3" style={{ height: '72px' }}>
                  <h6 className="card-title fw-bold text-dark mb-0" style={{ fontSize: '0.95rem' }}>{item.title}</h6>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default TopProperties;
